import { useState, useEffect, useCallback, useRef } from "react";
import DashboardPage from "./Dashboard.js";
import { MOCK } from "./MockData";
import Sidebar from "./SideBar";
import Header from "./Header";
import CustomersPage from "./Customer";
import OrdersPage from "./Orders";
import OrderPage from "./OrderPage";
import CollectionPage from "./Collection";
import ReportingPage from "./Reports";
import InventoryPage from "./inventory";
import DeliveriesPage from "./Delivery";
import AccountDetailPage from "./Accountdetails";
import AccountSettingsPage from "./Accountsettings";
import CreateOrderPage from "./CreateOrder";
import { Toasts, showToast } from "./SharedUI";

export default function App() {
  const [page, setPage] = useState("dashboard");
  const [notifs, setNotifs] = useState(MOCK.notifications);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);

  // styles are imported in index.css; no runtime injection needed

  const handleNotifRead = useCallback((id) => {
    setNotifs((p) => p.map((n) => (n.id === id ? { ...n, read: true } : n)));
    // API: API.notifications.markRead(id)
  }, []);

  const overdueCount = MOCK.collections.filter(
    (c) => c.status === "Overdue",
  ).length;
  const alertCount = MOCK.inventory.filter(
    (i) => i.status === "Critical" || i.status === "Low",
  ).length;
  const pendingCount = MOCK.orders.filter((o) => o.status === "Pending").length;

  const pages = {
    dashboard: <DashboardPage showToast={showToast} />,
    customers: <CustomersPage showToast={showToast} />,
    orders: (
      <OrdersPage
        showToast={showToast}
        onSelectOrder={(o) => {
          setSelectedOrder(o);
          setPage("order");
        }}
        setPage={setPage}
      />
    ),
    collection: <CollectionPage showToast={showToast} />,
    reporting: <ReportingPage showToast={showToast} />,
    inventory: <InventoryPage showToast={showToast} />,
    deliveries: <DeliveriesPage showToast={showToast} />,
    "account-detail": (
      <AccountDetailPage
        account={selectedAccount}
        showToast={showToast}
        onEdit={() => setPage("account-settings")}
      />
    ),
    "account-settings": <AccountSettingsPage showToast={showToast} />,
    order: (
      <OrderPage
        order={selectedOrder}
        setPage={setPage}
        showToast={showToast}
      />
    ),
    "create-order": <CreateOrderPage setPage={setPage} showToast={showToast} />,
  };

  return (
    <div className="shell">
      <Sidebar
        page={page}
        setPage={setPage}
        overdueCount={overdueCount}
        alertCount={alertCount}
        pendingCount={pendingCount}
      />
      <div className="main">
        <Header page={page} notifs={notifs} onNotifRead={handleNotifRead} setPage={setPage} />
        {pages[page] || <DashboardPage />}
      </div>
      <Toasts />
    </div>
  );
}
